"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEphemeralStore = void 0;
var react_1 = require("react");
var ioc_1 = require("../ioc");
/**
 * Resolves and holds the state for a new instance of a Store
 */
var useEphemeralStore = function (storeClass, container) {
    if (container === void 0) { container = ioc_1.getCoreContainer(); }
    var store = react_1.useState(function () { return container.resolve(storeClass); })[0];
    return { store: store };
};
exports.useEphemeralStore = useEphemeralStore;
//# sourceMappingURL=useEphemeralStore.js.map